import * as services from "@api";
import { v4 as uuid } from "uuid";
import { ProgressInfo } from "@components/progress";
import reactRender from "@src/utils/reactRender";
import { isType } from "@src/utils";
import { requiredValidate } from '../utils';
import { utils } from "ynf-core-middleware";
const { formatUtils } = utils;

const ROTATIONTIME = 2000;
let progressInstance: any;
export enum ExportType {
  "exportList", // 导出列表
  "exportDetail", // 导出详情
}
/**
 * @description: 列表导出
 * @param {any} rootStore
 * @param options {
 *  // 必填字段
 *  datasourceAlias: string，表实体别名
 *  filterStoreKey: string，查询store键值
 *  pagingStoreKey: string，分页store键值
 *  tableStoreKey: string，表store键值
 * }
 * @hooks {
 *  // 专有钩子
 *  beforeExportListHook: 详情请求前钩子
 *  afterExportListHook: 详情请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function exportList(rootStore: any, options: any = {}) {
  const { utils } = rootStore;
  try {
    requiredValidate.call(this, options, ["tableStoreKey", "filterStoreKey", "pagingStoreKey","datasourceAlias"]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }
  await exportFn.call(this, rootStore, options, ExportType.exportList);
}

/**
 * @description: 列表明细
 * @param {any} rootStore
 * @param options {
 *  // 必填字段
 *  datasourceAlias: string，表实体别名
 *  filterStoreKey: string，查询store键值
 *  pagingStoreKey: string，分页store键值
 *  tableStoreKey: string，表store键值
 * }
 * @hooks {
 *  // 专有钩子
 *  beforeExportDetailHook: 详情请求前钩子
 *  afterExportDetailHook: 详情请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function exportDetail(rootStore: any, options: any = {}) {
  const { utils } = rootStore;
  try {
    requiredValidate.call(this, options, ["tableStoreKey", "filterStoreKey", "pagingStoreKey","detailTplId","datasourceAlias","detailBillNo"]);
  } catch (e: any) {
    return utils.message.danger(e.message);
  }
  await exportFn.call(this, rootStore, options, ExportType.exportDetail);
}

// // test beforeExportListHook
// export const exportList = {
//   beforeExportListHook(rootStore:any, data:any) {
//     data.params.v = 1
//     return data
//   },
//   async doAction(rootStore: any, options: any = {}) {
//     await exportFn.call(this, rootStore, options, ExportType.exportList);
//   }
// }

export async function buildExportParams(
  rootStore: any,
  options: any = {},
  type: ExportType
) {
  const { utils = {}, pageStore = {}, context = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const { tableStoreKey, filterStoreKey, pagingStoreKey } = options;
  const serviceCode = query.serviceCode || params?.serviceCode || "ybbase";
  const tableStore = rootStore.get(tableStoreKey);
  let queryCondition: any;
  try {
    const filterStore = rootStore.get(filterStoreKey);
    queryCondition = filterStore.getQueryCondition();
  } catch (e) {}
  if (!tableStore) {
    throw new Error(`The tableStore[${tableStoreKey}] is not found`);
  }

  const billNo =
    type === ExportType.exportList
      ? params.billNo
      : options.detailBillNo;
  // 列表的话取 pageStore里面的，详情需要配置
  const tplId =
    type === ExportType.exportList ? params.tplId : options.detailTplId;
  const selectRows = tableStore.getSelectedRows();
  const paramsObj: any = {};
  if (selectRows.length) {
    paramsObj.ids = [];
    selectRows.forEach((row: any) => {
      paramsObj.ids.push(row.getValue(tableStore.primaryKey));
    });
    paramsObj.ids = paramsObj.ids.join(",");
  } else {
    await utils.confirm({
      title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005C', '提醒'),
      content: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005D', '确定导出全部数据？'),
    });
  }
  // 构建参数：
  paramsObj.asyncKey = `asyncOutput_${uuid()}`;
  // billnum
  paramsObj.billnum = billNo;
  paramsObj.cmdname = "cmdExport";
  // 查询条件
  paramsObj.extraCondition = queryCondition;
  // tplId
  paramsObj.tplId = tplId;
  paramsObj.externalData = {
    isAsync: true,
    fromUniteEntrance: true,
    actionName: "batchoutput",
    fileName: params.billName,
  };
  paramsObj.locale = context.locale ? context.locale : "zh_CN";
  if (selectRows.length) {
    paramsObj.suggestExportCount = selectRows.length;
  } else {
    const pagingStore = rootStore.get(pagingStoreKey);
    paramsObj.suggestExportCount = pagingStore
      ? pagingStore.total
      : tableStore.size();
  }
  // domainKey
  paramsObj.ownDomain = params.domainKey;
  paramsObj.domainKey = params.domainKey;
  paramsObj.fileName = params.billName;
  paramsObj.serviceCode = serviceCode;
  pageStore?.startLoading?.();
  const requestData = {
    params: {
      ...query,
      tplId: tplId,
      billnum: billNo,
      streaming: true,
      cmdname: paramsObj.cmdname,
      action: type === ExportType.exportList ? "output" : "listdetail",
      busiObj: options.busiObj || params.busiObj,
      // asyncKey: paramsObj.asyncKey,
      serviceCode,
      datasource: options.datasourceAlias,
    },
    data: paramsObj,
  };
  return requestData;
}
/**
 * 内部构建参数方法 exportFn
 * @param rootStore rootStore
 * @param options 参数
 * @param type 类型 exportList 导出列表 exportDetail 导出明细
 * @returns
 */
export async function exportFn(
  rootStore: any,
  options: any = {},
  type: ExportType
) {
  let requestData = await buildExportParams(rootStore, options, type);
  // 导出列表 前置钩子
  if (isType(this.beforeExportListHook, "Function")) {
    requestData = await this.beforeExportListHook(rootStore, requestData);
  }
  // 导出明细 前置钩子
  if (isType(this.beforeExportDetailHook, "Function")) {
    requestData = await this.beforeExportListHook(rootStore, requestData);
  }
  const res = await commonExport(requestData, rootStore);
  // 导出列表 后置钩子
  if (isType(this.afterExportListHook, "Function")) {
    await this.afterExportListHook(rootStore, res);
  }
  // 导出明细 后置钩子
  if (isType(this.afterExportDetailHook, "Function")) {
    await this.afterExportDetailHook(rootStore, res);
  }
}

/**
 * 通用的请求方法，导入时候下载模板使用
 * @param requestData 参数
 * @param rootStore
 * @returns
 */
export async function commonExport(requestData: any, rootStore: any) {
  let isDownLoad = false;
  const { utils = {}, pageStore = {} } = rootStore;
  const { params = {} } = pageStore;
  try {
    const startTime = formatUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");

    const res = await services.exportServer(requestData);
    if (res.code === 200) {
      utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005E', '导出任务已转入后台，可进行其他操作'));
      let timer: Timer;
      progressInstance = reactRender(
        ProgressInfo,
        { percentage: 0 },
        () => document.querySelector(".yb-async-float-progress")?.parentNode
      );
      async function getExportProcess() {
        try {
          requestData.params.asyncKey = requestData.data.asyncKey;
          const processRes = await services.getExportProcess({
            params: requestData.params,
          });
          if (processRes.code === 999) {
            clearInterval(timer);
            utils.message.danger(processRes.data.message);
          } else if (
            processRes.code === 200 &&
            Number(processRes.percentage) === 100 &&
            !isDownLoad
          ) {
            progressInstance?.update({ percentage: 100 });
            clearInterval(timer);
            setTimeout(() => {
              progressInstance?.destroy();
              rootStore.utils.notice.success({
                message: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005A', '导出请求已执行完毕'),
                description: lang.localeUuid('UID:P_CORE-YNF-FE_18952F4804500008', {startTime, billName: params.billName}),// 您于<%=startTime%>发起的【<%=billName%>】导出已经完成，文件名为<%=billName%>,请您参阅查看。
              });
            }, 200);

            let queryString = "";
            requestData.params.feV = 6;
            Object.keys(requestData.params).forEach((key: string) => {
              queryString += `&${key}=${requestData.params[key]}`;
            });
            window.open(
              window.__MAIN_ORIGIN__ +
                "/mdf-node/uniformdata/billtemp/downloadFileStream?" +
                queryString.substring(1)
            );
            isDownLoad = true;
          } else {
            // 设置进度球
            progressInstance?.update({ percentage: processRes.percentage });
          }
        } catch (e: any) {
          progressInstance?.destroy();
          utils.message.danger(e?.message);
          clearInterval(timer);
        }
      }
      timer = setInterval(async () => {
        getExportProcess();
      }, ROTATIONTIME);
      // 先调用一次
      getExportProcess();
    } else {
      utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B8005B', '导出失败'));
    }
  } catch (err: any) {
    utils.message.danger(err?.message);
    return Promise.reject(err);
  } finally {
    pageStore?.endLoading?.();
  }
}
